<template>
  <ImageGallery2023
    :images="mediaData"
    class="image-gallery"
    :preload="preload"
    sizes="xs:66vw sm:66vw md:80vw lg:636px"
    @zoom="handleLightboxOpen"
  />
</template>

<script setup lang="ts">
import { ImageGallery2023 } from '@i22team/td-longtail-vue-components';
import type { LocalImage } from '@i22team/rocket';
import { openModal } from '~/composables/modal';

export type ImageGalleryContainerProps = {
  preload?: boolean;
  mediaData: LocalImage[];
};

const props = withDefaults(defineProps<ImageGalleryContainerProps>(), {});

const handleLightboxOpen = (options?: { selectedImageIndex?: number }) => {
  openModal({
    noMaxWidth: true,
    className: 'image-gallery__modal',
    component: {
      is: markRaw(
        defineAsyncComponent(() => import('~/components/product-detail/image-gallery-modal.vue'))
      ),
      props: {
        images: props.mediaData,
        startIndex: options?.selectedImageIndex || 0,
      },
    },
  });
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.image-gallery {
  :deep(.image-gallery__image) {
    display: inline-block;
    height: auto;

    object-fit: contain;
    width: 100%;
    max-width: 100%;

    img {
      aspect-ratio: 1 / 1;
      width: 100%;
      height: 100%;
      max-height: 45vh;
      object-fit: contain;
    }
  }
}
</style>

<style lang="scss">
@use 'assets/base' as *;

.image-gallery__modal {
  .base-dialog__body {
    @include mq(false, $mq-sm - 1) {
      padding-inline: 0.5em;
    }
  }

  img.image-gallery-modal__image {
    width: 1000px;
    max-width: 100%;
  }

  .base-dialog__footer {
    display: none;
  }
}
</style>
